export enum NextStageTypeOptions {
  STAGE = 'Stage',
  FUNNEL = 'Funnel',
}
